import { render } from "./PopUpQuestionOrder.vue?vue&type=template&id=5fd87114"
import script from "./PopUpQuestionOrder.vue?vue&type=script&lang=js"
export * from "./PopUpQuestionOrder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__